<template>
  <div>
    <PageAllow controller="Payment" action="getPaySettings" />
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color">
      <v-card class="page-card">
        <v-card-title class="mx-3">
          {{ $t("Payment.wechatB2BPay.title") }}
          <v-spacer></v-spacer>
        </v-card-title>
        <v-progress-linear :indeterminate="loading"></v-progress-linear>
        <v-card-text>
          <ValidationObserver ref="observer">
            <v-container>
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("Payment.wechatB2BPay.application") + $t("Global.colon") }}
                </v-col>
                <v-col cols="9" md="7">
                  {{ $t("Payment.wechatB2BPay.application_title") }}
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Payment.wechatB2BPay.wechat_b2b_mchid") +
                    $t("Global.colon")
                  }}
                  <span class="red--text">*</span>
                </v-col>
                <v-col cols="9" md="7">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('Payment.wechatB2BPay.wechat_b2b_mchid')"
                    rules="required"
                  >
                    <v-text-field
                      v-model="settings.wechat_b2b_mchid"
                      single-line
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'wechat_b2b_mchid')
                          .concat(errors)
                      "
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Payment.wechatB2BPay.wechat_b2b_app_key") +
                    $t("Global.colon")
                  }}
                  <span class="red--text">*</span>
                </v-col>
                <v-col cols="9" md="7">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('Payment.wechatB2BPay.wechat_b2b_app_key')"
                    rules="required"
                  >
                    <v-text-field
                      v-model="settings.wechat_b2b_app_key"
                      single-line
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'wechat_b2b_app_key')
                          .concat(errors)
                      "
                    >
                      <!-- <template v-slot:message="{ key, message }">
                                <div :class="key == 0 ? 'danger--text' : ''">
                                {{ message }}
                                </div>
                            </template> -->
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <!-- X -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Payment.wechatB2BPay.wechat_mini_app_id") +
                    $t("Global.colon")
                  }}
                  <span class="red--text">*</span>
                </v-col>
                <v-col cols="9" md="7">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('Payment.wechatB2BPay.wechat_mini_app_id')"
                    rules="required"
                  >
                    <v-text-field
                      v-model="settings.wechat_mini_app_id"
                      single-line
                      disabled
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'wechat_mini_app_id')
                          .concat(errors)
                      "
                    >
                      <!-- <template v-slot:message="{ key, message }">
                                <div :class="key == 0 ? 'danger--text' : ''">
                                {{ message }}
                                </div>
                            </template> -->
                    </v-text-field>
                    <a @click="$router.push('/settings/mini-develop-program')">
                      {{ $t("Payment.wechatB2BPay.mini_develop_program") }}
                    </a>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <!-- X -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Payment.wechatB2BPay.wechat_mini_secret") +
                    $t("Global.colon")
                  }}
                  <span class="red--text">*</span>
                </v-col>
                <v-col cols="9" md="7">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('Payment.wechatB2BPay.wechat_mini_secret')"
                    rules="required"
                  >
                    <v-text-field
                      v-model="settings.wechat_mini_secret"
                      single-line
                      disabled
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'wechat_mini_secret')
                          .concat(errors)
                      "
                    >
                      <!-- <template v-slot:message="{ key, message }">
                                <div :class="key == 0 ? 'danger--text' : ''">
                                {{ message }}
                                </div>
                            </template> -->
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <!-- 启用 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Payment.wechatB2BPay.wechat_b2b_enable") +
                    $t("Global.colon")
                  }}
                </v-col>
                <v-col cols="9" md="7">
                  <v-radio-group row v-model="settings.wechat_b2b_enable">
                    <v-radio :label="$t('Payment.off')" key="0" value="0" />
                    <v-radio :label="$t('Payment.on')" key="1" value="1" />
                  </v-radio-group>
                </v-col>
              </v-row>
            </v-container>
          </ValidationObserver>
        </v-card-text>
      </v-card>
      <v-card class="page-opts">
        <v-card-title>
          <v-row dense>
            <v-col cols="12">
              <!-- 保存 -->
              <v-btn
                color="success"
                block
                @click="
                  settings.wechat_mini_enable ? (alertDialog = true) : save()
                "
              >
                <v-icon small class="pe-1">fa-save</v-icon>
                {{ $t("Payment.save") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
      </v-card>
    </v-sheet>

    <DialogAlert
      v-model="alertDialog"
      :message="$t('Payment.change_wechat_pay', [$t('Payment.wechatB2B')])"
      useConfirm
      @confirm="save()"
    />
  </div>
</template>

<script>
import Payment from "@/api/payment";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import DialogAlert from "@/components/plugins/DialogAlert";
import { mapState } from "vuex";
import { ValidationObserver, ValidationProvider } from "vee-validate";
// import Required from "@/components/plugins/Required";

export default {
  data: () => ({
    settings: {},
    serverErrors: [],
    alertDialog: false,
  }),
  components: {
    PageAllow,
    Breadcrumbs,
    DialogAlert,
    // Required,
    ValidationObserver,
    ValidationProvider,
  },

  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.fundManagement"),
        disabled: false,
        href: "/receipts",
      },
      {
        text: i18n.t("Nav.payment"),
        disabled: true,
        href: "/payment",
      },
    ],
    ...mapState(["loading"]),
  },

  mounted() {
    this.getAlipayFromAPI();
  },
  methods: {
    getAlipayFromAPI() {
      Payment.fetch({
        keys: [
          "wechat_b2b_mchid",
          "wechat_b2b_app_key",
          "wechat_mini_app_id",
          "wechat_mini_secret",
          "wechat_b2b_enable",
        ],
      }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.settings = response.data.settings;
            if (
              this.settings.wechat_b2b_enable == null ||
              typeof this.settings.wechat_b2b_enable == "undefined" ||
              this.settings.wechat_b2b_enable == undefined
            ) {
              this.settings.wechat_b2b_enable = "0";
            }
          }
        }.bind(this)
      );
    },

    save() {
      Payment.wechatB2BPaySave({
        wechat_b2b_mchid: this.settings.wechat_b2b_mchid,
        wechat_b2b_app_key: this.settings.wechat_b2b_app_key,
        wechat_b2b_enable: this.settings.wechat_b2b_enable,
      }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.$router.push("/payment");
          }
        }.bind(this)
      );
    },
  },
};
</script>

<style>
</style>